export const phantomModalContents = [
    {
        name: 'fighter',
        content: [
            <p>
                Good at using <span className='text-pborange'>swords</span> and physical attacks and are perfect on the
                front lines.
            </p>,
            <p>
                Possess the unique ability where the more surrounded by enemies they are, the higher their attack power
                gets. This means they're the{' '}
                <span className='text-pborange'>strongest when they're in a tough spot</span>!
            </p>,
            <p>
                Can learn many abilities. For example, if they have a{' '}
                <span className='text-pborange'>melee weapon equipped</span> when their physical and defense power
                rises, their turn will come around more quickly.
            </p>,
        ],
    },
    {
        name: 'witch',
        content: [
            <p>
                Character type specializing in <span className='text-pborange'>magic attacks</span>.
            </p>,
            <p>
                While they excel in <span className='text-pborange'>attacking enemies from afar</span>, they are{' '}
                <span className='text-pborange'>physically very weak</span>. Be sure to have a class like the Fighter
                protect them!
            </p>,
            <p>
                Remove and Move are lower than the Fighter, so be sure to not deploy them too early and have them
                <span className='text-pborange'> Removed before they can attack</span>.
            </p>,
        ],
    },
    {
        name: 'archer',
        content: [
            <p>
                A character that specializes in using bows. Can attack from the{' '}
                <span className='text-pborange'>back ranks</span>.
            </p>,
            <p>
                Deals more damage <span className='text-pborange'>by attacking enemies from a greater height</span>.{' '}
                <span className='text-pborange'>Perfect for stages with high vantage points.</span>
            </p>,
            <p>
                Weak to attacks and won't last long when in an enemy's range. Use height advantages and distance to
                <span className='text-pborange'> keep the enemy from getting too close</span>.
            </p>,
        ],
    },

    {
        name: 'striker',
        content: [
            <p>
                <span className='text-pborange'>Frontline fighters</span> with high physical defense that use{' '}
                <span className='text-pborange'>spears</span>.
            </p>,
            <p>
                Possess the unique ability to increase their attack power by moving, making them a great choice for a
                <span className='text-pborange'> mobile fighter</span>.
            </p>,
            <p>
                Have high physical defense, but <span className='text-pborange'>low magical defense</span>, so be
                careful!
            </p>,
        ],
    },
    {
        name: 'wizard',
        content: [
            <p>
                <span className='text-pborange'>Has a broader AOE range</span> than the similar magic class, the Witch, so
                they can attack more enemies from the backlines.
            </p>,
            <p>
                Just like the Witch, they have low physical defense and are not very mobile, but if you account for
                that, they are a class you can rely on to take care of{' '}
                <span className='text-pborange'>multiple foes</span>.
            </p>,
        ],
    },
    {
        name: 'healer',
        content: [
            <p>
                Not only does this class possess healing abilities, but they also increase the defense of all allies in
                range, so they can fulfill their role simply by being deployed as a{' '}
                <span className='text-pborange'>backline healer</span>.
            </p>,
            <p>
                Necessary for <span className='text-pborange'>the Heal Facility</span>, so having at least one will make
                your adventure easier.
            </p>,
        ],
    },
    {
        name: 'engineer',
        content: [
            <p>
                <span className='text-pborange'>A unique class</span> that allows you to use Gadget-related abilities
                such as building up more Mana.
            </p>,
           
            <p>
                Their real value is revealed when there are <span className='text-pborange'>Gadgets</span> on the map. Deploy them with Apricot to witness
                their true power!
            </p>,
        ],
    },
    {
        name: 'old man',
        content: [
            <p>Can use any close-range weapon well and is a <span className='text-pborange'>powerful frontline fighter</span>.</p>,
            <p>
                Though he has some peculiar abilities, his <span className='text-pborange'>high attack and defense</span> make him very useful in battle.
            </p>,
            <p>However, he will be Removed after only 2 turns, so he is <span className='text-pborange'>best used when you need a burst of power</span>.</p>,
        ],
    },
    {
        name: 'granny',
        content: [
            <p>
                The most powerful backline humanoid magic class. Has high INT and magical defense, which affects magic
                casting, and <span className='text-pborange'>high RES, which affects healing</span>.
            </p>,
            <p>Can also obtain abilities that increase the AOE and range of Skills.</p>,
            <p>
                However, like the Old Man, she will be Removed after only two turns, so <span className='text-pborange'>your timing is very important</span>.
            </p>,
        ],
    },
    {
        name: 'sailor',
        content: [
            <p>
                A peculiar mid-range unit that doesn’t have any special abilities or specialities, but instead has <span className='text-pborange'>the
                most turns</span> before being Removed.
            </p>,
            <p>Their abilities make them the target of attacks, so they’re useful for <span className='text-pborange'>shielding weaker allies</span>.</p>,
            <p>
                Train this class to get many abilities such as an ability to increase their Remove turns, get more EXP,
                decrease SP usage, and other <span className='text-pborange'>unique skills</span>. Maybe it would be worthwhile to raise one as a training
                exercise!?
            </p>,
        ],
    },
    {
        name: 'goat fighter',
        content: [
            <p>An exceptional warrior of the Goat tribe with the ability to <span className='text-pborange'>blow back</span> their enemies.</p>,
            <p>
                Their attack power increases as they move, and their other abilities increase with additional Goat tribe
                units on the map, making them an easy class to <span className='text-pborange'>power up</span>.
            </p>,
            <p>However, they are extremely weak to magic, so be careful!</p>,
        ],
    },
    {
        name: 'mer guard',
        content: [
            <p>A Mer tribe warrior with <span className='text-pborange'>strong defenses</span> who can protect their allies.</p>,
            <p>
                Can reliably protect allies with their Mer tribe characteristics of <span className='text-pborange'>being immune to status ailments</span> and
                having <span className='text-pborange'>high magic defense</span>.
            </p>,
            <p>Abilities increase with other Mer tribe units on the map.</p>,
        ],
    },
    {
        name: 'owl gunner',
        content: [
            <p>An Owl tribe class that uses guns and has <span className='text-pborange'>high JUMP power</span>.</p>,
            <p>Abilities increase with other Owl tribe units on the map.</p>,
            <p>Can toy with enemies by taking potshots at them from <span className='text-pborange'>high vantage points</span> while avoiding damage.</p>,
        ],
    },
]
